/* Elenco delle marche del configuratore + taratura dei colori.

   handle = la collezione su Shopify
   label  = il nome che compare sulla linguetta
   conv   = le scritte proposte per il convogliatore di quella marca

   Se aggiungi una marca nuova, aggiungila anche in
   assets/configuratore-apri.js (riquadro con il logo).

   I PREZZI non stanno qui: il configuratore legge le varianti vere della
   grafica scelta (cilindrata + finitura). */

/* TARATURA DEL RICONOSCIMENTO COLORI.
   - scuro / satScuro : cosa consideriamo contorno scuro
   - raggio           : spessore massimo di un contorno
   - alone            : pixel di sfumatura da togliere attorno al contorno
   - neroMax          : fin dove un pezzo e nero (e quindi non si tocca)
   - biancoMin        : da dove in su e bianco (non si tocca)
   - soloNominati     : usa solo i colori scritti nel titolo
   - dueToni          : stacca chiaro e scuro dentro la stessa tinta
   - deltaTono        : quanto devono essere diversi i due toni (0-1)
   - quotaTono        : quanto deve pesare ognuno dei due (0-1) */
window.BC_TARATURA = {
  biancoMin: 0.88,
  dueToni: true,
  deltaTono: 0.16,
  quotaTono: 0.15
};

window.BC_COLLECTIONS = [
  { handle: 'grafiche-hm-personalizzate-50-e-125', label: 'HM', conv: ['VENT', 'HONDA', 'CRM'] },
  { handle: 'grafiche-personalizzate-beta-50-e-125', label: 'Beta', conv: ['BETA'] },
  { handle: 'grafiche-husqvarna-personalizzabili', label: 'Husqvarna', conv: ['HUSQVARNA'] },
  { handle: 'grafiche-tm-personalizzate', label: 'TM', conv: ['TM'] },
  { handle: 'grafiche-fantic-personalizzate', label: 'Fantic', conv: ['FANTIC'] },
  { handle: 'grafiche-valenti', label: 'Valenti', conv: ['VALENTI'] },
  { handle: 'grafiche-suzuki', label: 'Suzuki', conv: ['SUZUKI'] },
  { handle: 'grafiche-gas-gas', label: 'Gas Gas', conv: ['GAS GAS'] },
  { handle: 'grafiche-sherco', label: 'Sherco', conv: ['SHERCO'] },
  { handle: 'grafiche-ktm-motard', label: 'KTM Motard', conv: ['KTM'] },
  { handle: 'grafiche-ktm-duke', label: 'KTM Duke', conv: ['KTM'] },
  { handle: 'grafiche-ktm-adventure', label: 'KTM Adventure', conv: ['KTM'] },
  { handle: 'grafiche-yamaha-motard', label: 'Yamaha Motard', conv: ['YAMAHA'] },
  { handle: 'grafiche-yamaha-stradale', label: 'Yamaha Stradale', conv: ['YAMAHA'] },
  { handle: 'grafiche-yamaha-adventure', label: 'Yamaha Adventure', conv: ['YAMAHA'] },
  { handle: 'grafiche-kawasaki-motard', label: 'Kawasaki Motard', conv: ['KAWASAKI'] },
  { handle: 'grafiche-kawasaki-stradale', label: 'Kawasaki Stradale', conv: ['KAWASAKI'] },
  { handle: 'grafiche-honda', label: 'Honda', conv: ['HONDA'] },
  { handle: 'grafiche-honda-stradale', label: 'Honda Stradale', conv: ['HONDA'] },
  { handle: 'grafiche-honda-adventure', label: 'Honda Adventure', conv: ['HONDA'] },
  { handle: 'grafiche-bmw-adventure', label: 'BMW', conv: ['BMW'] }
];

/* Tira dentro gli altri pezzi del configuratore.
   IMPORTANTE: teniamo il ?v=... di questo file anche sugli altri due,
   altrimenti Shopify serve la versione vecchia dalla cache. */
(function () {
  var me = document.currentScript;
  if (!me) {
    var tutti = document.getElementsByTagName('script');
    me = tutti[tutti.length - 1];
  }
  if (!me || !me.src) return;
  var src = me.src;
  var q = src.indexOf('?');
  var percorso = q >= 0 ? src.slice(0, q) : src;
  var versione = q >= 0 ? src.slice(q) : '';
  ['configuratore-colori.js', 'configuratore-scelte.js'].forEach(function (nome) {
    var url = percorso.replace('configuratore-marche.js', nome) + versione;
    if (document.querySelector('script[src="' + url + '"]')) return;
    var s = document.createElement('script');
    s.src = url;
    s.async = false;
    document.head.appendChild(s);
  });
})();
